import http from '../../../../api/http';
import type { Permiso } from '../types/usuario.types';

export const permisoService = {
  async getAll(): Promise<Permiso[]> {
    const response = await http.get('/permiso');
    return response.data;
  },

  async getById(id: number): Promise<Permiso> {
    const response = await http.get(`/permiso/${id}`);
    return response.data;
  },

  async getByModulo(idModulo: number): Promise<Permiso[]> {
    const response = await http.get(`/permiso/modulo/${idModulo}`);
    return response.data;
  },

  async save(permiso: Permiso): Promise<Permiso> {
    if (permiso.id === 0) {
      const response = await http.post('/permiso', permiso);
      return response.data;
    } else {
      const response = await http.put(`/permiso/${permiso.id}`, permiso);
      return response.data;
    }
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/permiso/${id}`);
  }
};
